/**
 * General NI Util Class
 */
window.Util = {
	ajaxDoktype: 4815162342,
	cdnDomains: {
		production: {
			'js': '//www.native-instruments.com',
			'css': '//www.native-instruments.com',
			'img': '//www.native-instruments.com'
		},
		staging: {
			'js': '//www.staging.native-instruments.com',
			'css': '//www.staging.native-instruments.com',
			'img': '//www.staging.native-instruments.com'
		}
	},
	isStagePage: function () {
		return (typeof stagePage !== 'undefined');
	},
	isMobile: function () {
		return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/).test(navigator.userAgent);
	},
	isDefaultPage: function () {
		return (typeof defaultPage !== 'undefined' || (!Util.isStagePage() && !Util.isMobilePage()));
	},
	isWwwPage: function () {
		return (window.location.hostname.indexOf('www') == 0 && !Util.isKnowledgePage());
	},
	isKnowledgePage: function () {
		return (typeof knowledgebase !== 'undefined' );
	},
	isShopPage: function () {
		return (window.location.hostname.indexOf('shop') == 0);
	},
	isMac: function () {
		return (navigator.appVersion.toLowerCase().indexOf('mac') !== -1);
	},
	isWin: function () {
		return (navigator.appVersion.toLowerCase().indexOf('win') !== -1);
	},
	isIE: function () {
		return (navigator.userAgent.toLowerCase().indexOf('msie') !== -1);
	},
	isLessThanIE9: function () {
		return (jQuery.browser.msie && jQuery.browser.version < 9);
	},
	isLessThanIE10: function () {
		return (jQuery.browser.msie && jQuery.browser.version < 10);
	},
	isFirefox: function () {
		return (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1);
	},
	isAppleMobileDevice: function () {
		return (navigator.userAgent.toLowerCase().match(/(ipad|iphone|ipod)/i));
	},
	isIphone: function () {
		return (navigator.userAgent.toLowerCase().match(/(iphone|ipod)/i));
	},
	isIpad: function () {
		return (navigator.userAgent.toLowerCase().match(/(ipad)/i));
	},
	isNumber: function (val) {
		return !isNaN(parseFloat(val)) && isFinite(val);
	},
	isSessionStorageEnabled: function () {
		return (!!localStorage.getItem);
	},
	isLocalStorageEnabled: function () {
		return (!!localStorage.getItem);
	},
	isTagManagerLoaded: function () {
		return (typeof window.google_tag_manager !== 'undefined');
	},
    isInViewport: function (elem) {

        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = $(elem).offset();
        bounds.right = bounds.left + $(elem).outerWidth();
        bounds.bottom = bounds.top + $(elem).outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    },
	/**
	 * @param url {String}
	 * @return {Boolean}
	 */
	isNiUrl: function (url) {
		if (!url) {
			return false;
		}
		return (url.match(/(^((http|https):)?\/\/((www|shop|co|m)?\.([\-a-z]*\.)?native-instruments\.(de|com)))|(^\/)/)) ? true : false;
	},
	detectIosPrivateMode: function () {
		var testKey = 'test', storage = window.sessionStorage;
		try {
			storage.setItem(testKey, '1');
			storage.removeItem(testKey);
			return true;
		} catch (error) {
			return false;
		}
	},
	getProtocol: function () {
		return window.location.protocol;
	},
	getWwwDomain: function () {
		if (!Util.isNiUrl('//' + window.location.host)) {
			return false;
		}
		return '//' + window.location.host.replace(/^(shop|co|m)/, 'www');
	},
	getShopDomain: function () {
		if (!Util.isNiUrl('//' + window.location.host)) {
			return false;
		}
		return '//' + window.location.host.replace(/^(www|co|m)/, 'shop');
	},
	/**
	 * @return {*}
	 */
	getLang: function () {
		try {
			var lang = jQuery('html').attr('lang').toLowerCase().split('-')[0];
			return lang === 'ja' ? 'jp' : lang;
		} catch (e) {
			try {
				return window.location.href.toLowerCase().match(/native-instruments.(com|de)\/#?\/?(en|de|jp)\//)[2];
			} catch (e) {
				try {
					var code = window.location.href.match(/native-instruments.(com|de)\/(.*)(\?|\&)L=(\d)/)[4];
					if (code) {
						return (code === 2) ? 'de' : ((code === 5) ? 'jp' : 'en');
					}
				} catch (e) {
					try {
						return jQuery('meta[http-equiv=Content-Language]').attr("content").toLowerCase();
					} catch (e) {
						if (Util.getCookie('user_ni_user_language') !== null) {
							return Util.getCookie('user_ni_user_language');
						}
					}
				}
			}
		}
		return '';
	},
	/**
	 * @return {*}
	 */
	getCountry: function () {
		if (Util.getCookie('localization_country') !== null) {
			return Util.getCookie('localization_country');
		}
		return '';
	},
	/**
	 * @param key {String}
	 * @param json {String} with translations
	 * @return {*}
	 */
	getTranslation: function (key, json) {
		return json.data[key][Util.getLang()];
	},
	/**
	 * @returns {boolean}
	 */
	isProductionMode: function () {
		return typeof(devMode) === 'undefined';
	},
	/**
	 * Calculates the size of a object
	 * @param obj
	 * @returns {number}
	 */
	getObjectSize: function (obj) {
		var size = 0, key;
		for (key in obj) {
			if (obj.hasOwnProperty(key)) size++;
		}
		return size;
	},
	/**
	 * @returns {*}
	 */
	getTypoSessionId: function () {
		var id = Util.getCookie(Account.sessionCookie);
		return (id) ? id : '';
	},
	getRandomString: function () {
		return Math.random().toString(36).substring(2);
	},
	refreshPage: function () {
		location.reload(true);
	},
	/**
	 * @param uri
	 * @param key
	 * @param value
	 * @return {*}
	 */
	updateUrlQueryParameter: function (uri, key, value) {
		var re = new RegExp("([?|&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return uri + separator + key + "=" + value;
		}
	},
	getCookieDomain: function () {
		var domainParts = window.location.hostname.split('.');
		domainParts.shift();
		return '.' + domainParts.join('.')
	},
	/**
	 * @param name {String}
	 * @param value {String}
	 * @param domain {String}
	 * @param expires {Number} in seconds
	 * @param path {String}
	 * @param secure {Boolean}
	 * @return {String}
	 */
	setCookie: function (name, value, domain, expires, path, secure) {
		if (!domain) {
			domain = Util.getCookieDomain();
		}
		if (document.cookie) {
			var d = new Date();
			var ck = encodeURIComponent(name) + "=" + encodeURIComponent(value);
			ck += (domain) ? "; domain=" + domain : "";
			if (expires !== null && parseInt(expires) !== 0) {
				expires = new Date((d.getTime() + 1000 * expires));
				expires = expires.toGMTString();
				ck += "; expires=" + expires;
			}
			ck += (path) ? "; path=" + path : "; path=/";
			ck += (secure) ? "; secure" : "";
			document.cookie = ck;
		}
		return '';
	},
	/**
	 * @param name
	 * @return {*}
	 */
	getCookie: function (name) {
		if (document.cookie) {
			var arr = document.cookie.split(decodeURIComponent(name) + '=');
			if (arr.length >= 2) {
				var arr2 = arr[1].split(';');
				return decodeURIComponent(arr2[0]);
			}
		}
		return null;
	},
	/**
	 * @param name
	 * @param domain
	 * @param path
	 */
	removeCookie: function (name, domain, path) {
		Util.setCookie(name, '', domain, -1, path);
	},
	/**
	 * @access private
	 * @param url The url
	 * @return object
	 */
	queryParams: function (url) {
		var queryString = {};
		if (url.match(/\?|&/)) {
			url.split("?").pop().split("&").forEach(function (prop) {
				var item = prop.split("=");
				queryString[item.shift()] = item.shift();
			});
		}
		return queryString;
	},
	/**
	 * @param name
	 * @return {String}
	 */
	getParameter: function (name) {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var pattern = "[\\?&]" + name + "=([^&#]*)";
		var regex = new RegExp(pattern);
		var results = regex.exec(window.location.search);
		if (results === null) {
			return "";
		} else {
			return decodeURIComponent(results[1].replace(/\+/g, " "));
		}
	},
	/**
	 * @param uri
	 * @param key
	 * @param value
	 * @return {*}
	 */
	addParameter: function (uri, key, value) {
		var re = new RegExp("([?|&])" + key + "=.*?(&|$)", "i");
		var separator = uri.indexOf('?') !== -1 ? "&" : "?";
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return uri + separator + key + "=" + value;
		}
	},
	/**
	 *
	 * @param uri
	 * @param key
	 * @returns {*}
	 */
	removeParameter: function (uri, key) {
		var parts = uri.split('?');
		if (parts.length > 1) {
			var prefix = encodeURIComponent(key) + '=',
				pars = parts[1].split(/[&;]/g);
			for (var i = pars.length; i-- > 0;)
				if (pars[i].lastIndexOf(prefix, 0) !== -1) {
					pars.splice(i, 1);
				}
			return parts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
		} else {
			return uri;
		}
	},
	/**
	 * @param url
	 * @param callback
	 */
	getAjaxContent: function (url, callback) {
		jQuery.ajax({
			url: Util.addParameter(url, 'type', Util.ajaxDoktype),
			crossDomain: true,
			xhrFields: {
				withCredentials: true
			},
			success: callback
		});
	},
	/**
	 * Insert scripts from ajax request into page
	 * @param content
	 * @param callback
	 * @return Promise
	 */
	insertScripts: (function() {
		var loadedScripts = [],
			loadedStyles = [];

		return function (content, callback) {
			var scripts = jQuery(content).find('.script');
			var css = jQuery(content).find('.css-style');

			// Update the loaded scripts that were not loaded by this method
			jQuery('script[src!=""]').each(function() {
				var url = jQuery(this).attr('src');
				if (url && loadedScripts.indexOf(url) === -1) {
					loadedScripts.push(url);
				}
			});

			// Update the loaded styles that were not loaded by this method
			jQuery('link[rel=stylesheet]').filter('[href!=""]').each(function() {
				var url = jQuery(this).attr('src');
				if (url && loadedStyles.indexOf(url) === -1) {
					loadedStyles.push(url);
				}
			});

			// Add CSS files to header but don't wait for them to load
			css
				.filter(function(index, link) {
					return link && (loadedStyles.indexOf(jQuery(link).data('url')) === -1 || !jQuery(link).data('once'));
				})
				.map(function(index, link) {
					return $(link).data('url');
				}).each(function (index, url) {
					loadedStyles.push(url);
					$('head').append($('<link rel="stylesheet" type="text/css" />').attr('href', url));
				});

			// Load all necessary javascript files and wait asynchronously for them
			var promise = jQuery.Deferred().resolve();
			scripts
				.filter(function(index, script) {
					return script && (loadedScripts.indexOf(jQuery(script).data('url')) === -1 || !jQuery(script).data('once'));
				})
				.map(function(index, script) {
					return $(script).data('url');
				})
				.each(function(index, url) {
					loadedScripts.push(url);
					promise = promise.then(function() {
						return Util.getScript(url);
					});
				});
			return promise.always(callback);
		};
	})(),
	/**
	 * Get a script and put it in the header
	 * @param url
	 * @param callback
	 *  @return Promise
	 */
	getScript: function (url, callback) {
		return jQuery.ajax({
			url: url,
			dataType: 'script',
			success: callback
		});
	},
	ensureLoaded: (function() {
		var promises = {};

		return function(urls) {

			var promise = jQuery.Deferred().resolve();

			urls.forEach(function(url, i) {
				promise = promise
					.then(function() {
						if (!promises[url]) {
							promises[url] = jQuery.get(url + '?1537956840')
								.then(function(response) {
									if (urls[i].split('.').pop() === 'css') {
										$('head').append('<style>' + response + '</style>');
									}
								});
						}
						return promises[url];
					})
			});

			return promise;
		}
	})(),
	/**
	 * @param id
	 */
	scrollTo: function (id) {
		jQuery('html,body').animate({
			scrollTop: jQuery(id).offset().top
		}, 600);
	},
	/**
	 * location.href is bad, loses referrer
	 * @param url
	 */
	goToUrl: function (url) {
		var a = document.createElement('a');
		if (a.click) {
			// HTML5 browsers and IE support click() on <a>, early FF does not.
			a.setAttribute('href', url);
			a.style.display = 'none';
			document.body.appendChild(a);
			a.click();
		} else {
			// Early FF can, however, use this usual method
			// where IE cannot with secure links.
			window.location = url;
		}
	},
	/**
	 * @param str
	 */
	removeSessionStorageByString: function (str) {
		for (var i = 0; i < sessionStorage.length; i++) {
			if (sessionStorage.key(i).indexOf(str) !== -1) {
				sessionStorage.removeItem(sessionStorage.key(i));
			}
		}
	},
	/**
	 * @return {*}
	 */
	getBasketCount: function () {
		return (Util.getCookie('basketcounter')) ? Util.getCookie('basketcounter') : 0;
	},
	/**
	 * @returns {*}
	 */
    getCacheKey: function (userScope) {
        if (!userScope && typeof cacheKey !== 'undefined') {
            return cacheKey;
        }
        if (userScope && Util.getCookie('uuh')) {
            return Util.getCookie('uuh');
        }
        var d = new Date();
        return d.getDate() + '-' + d.getHours() + '-' + Math.round(d.getMinutes() / 30);
    },
	/**
	 * @param key [js|css|img]
	 * @returns {*}
	 */
	getCdnDomain: function (key) {
		return '';
		/*if (window.location.protocol !== 'https:') {
		 if (Util.getCookieDomain() == '.native-instruments.com') {
		 return Util.cdnDomains['production'][key];
		 } else if (Util.getCookieDomain() == '.staging.native-instruments.com') {
		 return Util.cdnDomains['staging'][key];
		 }
		 }
		 return '';*/
	},
	/**
	 * converts number values separated by character, eg. 100000 to 100.000
	 * @param number
	 * @returns {string}
	 */
	formatCount: function (number) {
		number = '' + number;
		if (number.length > 3) {
			var mod = number.length % 3;
			var output = (mod > 0 ? (number.substring(0, mod)) : '');
			for (i = 0; i < Math.floor(number.length / 3); i++) {
				if ((mod === 0) && (i === 0)) {
					output += number.substring(mod + 3 * i, mod + 3 * i + 3);
				}
				else {
					// define dividing char
					output += '.' + number.substring(mod + 3 * i, mod + 3 * i + 3);
				}
			}
			return (output);
		} else {
			return number;
		}
	},
	/**
	 * Detects preferred language
	 * @returns {*}
	 */
	getPreferredLanguage: function () {
		var preferred, key = 'preferred-language-' + Util.getCacheKey();
		preferred = sessionStorage.getItem(key);
		if (preferred === null) {
			jQuery.ajax({
				url: Util.getWwwDomain() + '/typo3conf/ext/ni_assets/Resources/Public/Scripts/language.php',
				dataType: 'jsonp',
				async: false,
				success: function (data) {
					if (data.preferred) {
						preferred = data.preferred;
						if (Util.detectIosPrivateMode()) {
							sessionStorage.setItem(key, preferred);
						}
					}
				}
			});
		}
		return preferred;
	},
	/**
	 * @param elm
	 * @param arr
	 * @returns {*}
	 */
	removeArrayElement: function (elm, arr) {
		var index = arr.indexOf(elm);
		if (index > -1) {
			arr.splice(index, 1);
		}
		return arr;
	},

	/**
	 *
	 * @param text
	 * @param maxLength
	 * @returns {*}
	 */
	shorten: function (text, maxLength) {
		var ret = text;
		if (ret.length > maxLength) {
			ret = ret.substr(0, maxLength - 3) + "...";
		}
		return ret;
	},

	removeStorageItem: function (key, options) {
        key += Util.getCacheKey(options && options.userScope);

        var storage = options.permanent ? window.localStorage : window.sessionStorage;

        if (!storage) {
            return false;
        }

        return storage.removeItem(key);
    },

	/**
	 *
	 * @param key
	 * @returns {*}
	 */
	getStorageItem: function (key, options) {
		key += Util.getCacheKey(options && options.userScope);

        var storage = options.permanent ? window.localStorage : window.sessionStorage;

        if (!storage) {
			return false;
		}

        return jQuery.parseJSON(storage.getItem(key));
	},

	/**
	 *
	 * @param key
	 * @returns {*}
	 */
	setStorageItem: function (key, value, options) {
		options = options || {};

		key += Util.getCacheKey(options.userScope);

        var storage = options.permanent ? window.localStorage : window.sessionStorage;

		if (!storage) {
			return false;
		}

		if (options.merge) {
			value = jQuery.extend({}, value, Util.getStorageItem(key, options));
		}

		storage.setItem(key, JSON.stringify(value));

		return value;
	},

	/**
	 *
	 * @param value
	 * @param length
	 * @returns {*|string}
	 */
	pad: function (value, length) {
		value = String(value);
		length = length || 2;
		while (value.length < length) {
			value = '0' + value;
		}
		return value;
	},

	/**
	 *
	 * @param str
	 * @returns {string}
	 */
	formatDate: function (str) {
		var o = new Date(str);
		if (o instanceof Date && !isNaN(o.getTime())) {
			var m = Util.pad(o.getMonth() + 1, 2),
				y = o.getFullYear(),
				d = Util.pad(o.getDate(), 2);
			return Util.getCountry() === 'US' ? m + '/' + d + '/' + y : d + '.' + m + '.' + y;
		}
		return '';
	},

	/**
	 * throttles function execution, e.g. for keydown/keyup events
	 * @param func
	 * @param wait
	 */
    throttle: function (func, wait) {
        return function () {
            var that = this,
                args = arguments;

            clearTimeout(func._throttleTimeout);

            func._throttleTimeout = setTimeout(function () {
                func.apply(that, args);
            }, wait);
        };
	},

    /**
	 *
     * @param Function createPromise
     */
	cachePromise: function(createPromise) {

        var promise = null;

        return function() {
            if (!promise) {
                promise = createPromise();
            }
            return promise;
        };
	},

	/**
	 * Extracts the price number value of a price with currency and normalizes the format to xxxxxx.xx
	 * @param string priceAsString
	 */
	extractPriceValue: function(priceAsString) {
		var price = '';

		try {
			var parts = priceAsString
				.match(/.*?((?:\d+(?:\.|,))+\d+).*?/)[1]
				.replace(',', '.')
				.split('.');

			price = parts.slice(0, -1).join('') + '.' + parts.slice(-1);
		}
		catch(exception) {
		}

		return price;
	},

	i18n: (function i18n() {
		var translationTable = {};
		return {
			get: function(key, defaultValue) {
				return translationTable.hasOwnProperty(key)
					? translationTable[key]
					: (defaultValue === undefined ? key : defaultValue);
			},
			add: function(translations) {
				if (typeof translations === "object") {
					for (var i in translations) {
						if (translations.hasOwnProperty(i)) {
							translationTable[i] = translations[i];
						}
					}
				}
			}
		}
	})(),

	arrayDiff: function(arr1, arr2)
	{
		return arr1.filter(function(i) {return arr2.indexOf(i) < 0;});
	},

	log: function() {
		if (window.devMode) {
			console.log.apply(console, arguments);
		}
	}



};
